import React, { useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/course-subjects/CourseSubjectsAction";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { CourseSubjectEditForm } from "./CourseSubjectEditForm";

export function CourseSubjectEdit({
  history,
  match: {
    params: { page, id, courseId }
  }
}) {
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, courseSubject } = useSelector(
    (state) => ({
      actionsLoading: state.courseSubjects.actionsLoading,
      isSuccess: state.courseSubjects.isSuccess,
      type: state.courseSubjects.type,
      courseSubject: state.courseSubjects.courseSubject
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCourseSubject(id, courseId));
    return () => dispatch(actions.cleanCourseSubjectsState());
  }, [id, courseId, dispatch]);
  
  const saveCourseSubject = (values) => {
    dispatch(actions.saveCourseSubject(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);

    if (isSuccess) {
      setTimeout(() => {
        if (page === "ogretmen") history.push(`/ogretmen/ders-konulari/${courseId}`);
        else history.push(`/ders-konulari/${courseId}`);    
      }, 2500);
    }
  };

  const btnRef = useRef();  
  const saveCourseSubjectClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Kimlik, Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  let title = "Ders Konusu";
  let action = id ? "Düzenle" : "Ekle";
  title += " " + action;
  title = <>{title} (<span style={{color:"red"}}>{courseSubject.course}</span>)</>
        
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <CourseSubjectEditForm 
            courseSubject={courseSubject}
            btnRef={btnRef} 
            saveCourseSubject={saveCourseSubject}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveCourseSubjectClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}